import { useForm, useFormState } from "react-hook-form";
import { mixed, object, string } from "yup";
import Validations from "@helpers/validations";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

const DEFAULT_VALUES = {
    name      : "",
    admin_name: "",
    email     : "",
    password  : "",
    status    : "active",
    timezone  : "",
    title     : "",
    phone     : ""
};

const useUpsert = (props) => {
    const {
        modalConfig: { row },
        handleModal,
        getOrganizations
    } = props;

    const { loading, axiosInstance } = useAxios({ base: "superAdmin" });

    const { requiredValidation, emailRequiredValidation } = Validations();

    const methods = useForm({
        defaultValues: DEFAULT_VALUES,

        resolver: yupResolver(
            object().shape({
                name      : requiredValidation({ name: "Organization Name" }),
                admin_name: requiredValidation({ name: "Admin Name" }),
                email     : emailRequiredValidation({ name: "Email" }),
                password  : string(),
                status    : string(),
                region    : object().shape({
                    timezone: mixed().nullable()
                }),
                title: string(),
                phone: string()
            })
        )
    });

    const { control, handleSubmit, reset } = methods;
    const { isDirty } = useFormState({ control });

    useEffect(() => {
        if (size(row)) {
            reset({
                name      : row.name || "",
                admin_name: row.admin?.name || "",
                email     : row.admin?.email || "",
                password  : "",
                status    : row.status || "active",
                region    : {
                    timezone: row.admin?.region?.timezone
                },
                title: row.admin?.title || "",
                phone: row.admin?.phone || ""
            });
        } else {
            reset(DEFAULT_VALUES);
        }
    }, [row]);
    const onSubmit = handleSubmit(async (data) => {
        let payload;

        if (row._id) {
            payload = {
                name  : data.name,
                status: data.status
            };

            await axiosInstance.patch(`/organizations/${row._id}`, payload);
        } else {
            payload = {
                name      : data.name,
                status    : data.status,
                admin_name: data.admin_name,
                email     : data.email,
                region    : {
                    timezone: data.region?.timezone
                },
                title: data.title,
                phone: data.phone
            };

            if (data.password) {
                payload.password = data.password;
            }

            await axiosInstance.post("/organizations", payload);
        }

        handleModal();
        getOrganizations();
    });

    return {
        onSubmit,
        methods,
        updateLoading: loading,
        isDirty
    };
};

export default useUpsert;
